import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Btn, H2, H4 } from "../../AbstractElements";
import { URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import SweetAlert from 'sweetalert2';

import { formatDate, formatPrice, itemHasPermission } from "../../utils/helper/helpers";
import '../../utils/helper/style.css';
import useCarburantsListe, { cardCarburant, deleteCarburant, monthPayed, singlePayed } from "./CarburantApi";
import useInfosEts from "../InfosEts/InfoApi";
import { Link } from "react-router-dom";

type Carburant = { [key: string]: any }

const GestCarburant = () => {
    const [filterText, setFilterText] = useState("");
    const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
    const [filteredItems, setFilteredItems] = useState<Carburant[]>([]);
    const [refresh, setRefresh] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const carburants = useCarburantsListe(refresh) || [];
    const etablissement = useInfosEts(refresh) || [];

    const [data, setData] = useState({
        immatriculation: '',
        designation: '',
        quantite_litre: 1,
        prix_par_litre: 12000,
        montant: 0,
        etsInfos: 0,
        recever: '',
        date_carburant: '',
        id: null
    });
    const [erreur, setErreur] = useState({
        immatriculation: '',
        designation: '',
        quantite_litre: '',
        prix_par_litre: '',
        etsInfos: '',
        montant: '',
        recever: '',
        date_carburant: '',
        id: null
    });

    const [filter, setFilter] = useState({
        month: '',
        date_debut: '',
        date_fin: '',
        status: ''
    });

    // useEffect : Récupération initiale des filtres sauvegardés
    useEffect(() => {
        const savedFilterText = localStorage.getItem("filterText_carburant") || "";
        const savedSelectedMonth = localStorage.getItem("selectedMonth_carburant");
        const savedStatusFilter = localStorage.getItem("statusFilter_carburant") || "";

        setFilterText(savedFilterText);
        setSelectedMonth(savedSelectedMonth ? parseInt(savedSelectedMonth) : null);
        setFilter((prev) => ({ ...prev, status: savedStatusFilter }));
    }, []);

    // useEffect : Sauvegarde des filtres dans localStorage à chaque changement
    useEffect(() => {
        localStorage.setItem("filterText_carburant", filterText);
        localStorage.setItem("selectedMonth_carburant", selectedMonth ? selectedMonth.toString() : "");
        localStorage.setItem("statusFilter_carburant", filter.status || "");
    }, [filterText, selectedMonth, filter.status]);

    // Fonction pour réinitialiser les filtres
    const clearFilters = () => {
        localStorage.removeItem("filterText_carburant");
        localStorage.removeItem("selectedMonth_carburant");
        localStorage.removeItem("statusFilter_carburant");

        setFilterText("");
        setSelectedMonth(null);
        setFilter((prev) => ({ ...prev, status: "" }));
    };

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const clearDataForm = () => {
        setData({
            immatriculation: '',
            designation: '',
            quantite_litre: 0,
            prix_par_litre: 12000,
            montant: 0,
            recever: '',
            etsInfos: 0,
            date_carburant: '',
            id: null
        });
        setErreur({
            immatriculation: '',
            designation: '',
            quantite_litre: '',
            prix_par_litre: '',
            montant: '',
            recever: '',
            etsInfos: '',
            date_carburant: '',
            id: null
        });
    }

    const editerData = ({ id }: { id: number }) => {
        const data = filteredItems.find((item) => item.id === id);
        if (data) {
            setData({
                immatriculation: data.immatriculation,
                designation: data.designation,
                quantite_litre: data.quantite_litre,
                prix_par_litre: data.prix_par_litre,
                montant: data.montant,
                etsInfos: data.ets_id,
                recever: data.recever,
                date_carburant: data.date_carburant,
                id: data.id
            });
        } else {
            toast.info('Cet element de figure pas dans nos données')
        }

    }

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        const url = data.id !== null ? `${URL_API}/carburant/update/${data.id}` : `${URL_API}/carburant/store`
        const Token = JSON.parse(localStorage.getItem("login")!);

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {

            if (response.data.success) {
                const msg = data.id !== null ? "Carburant modifié avec succès !!" : "Carburant ajouté avec succès !!";
                toast.success(msg);
                clearDataForm();
            }


        }).catch(error => {
            toast.info("Oups !! Erreur de modification des données");
            if (error.status == 405) {
                setErreur(error.response.data.message);
            }
        })
        setRefresh((prev) => !prev);
        setIsSubmitting(false);
    }
    const handleSubmit = () => {
        const month = selectedMonth ? selectedMonth : new Date().getMonth() + 1
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: `De Vouloir Payer les bons du ${month} eme mois ??`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, Payer !'
        }).then((result) => {
            if (result.isConfirmed) {
                monthPayed({ value: month }, () => setRefresh(!refresh))
            }
        });

    };

    // Fonction pour gérer le changement de filtre
    const changeFilter = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilter((prev) => ({ ...prev, [name]: value }));
    };

    const Confirmation = ({ id, type }: { id: number, type: string }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: type == 'supprimer' ? "De Vouloir Supprimer cet element ??" : "De vouloir designer cet element comme payé",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: type == 'supprimer' ? 'Oui, Supprimer !' : 'Oui, Payer'
        }).then((result) => {
            if (result.isConfirmed) {
                type == 'supprimer' ? deleteCarburant({ id: id }, () => setRefresh(!refresh)) : singlePayed({ value: id }, () => setRefresh(!refresh));
            }
        });
    };

    useEffect(() => {
        const currentMonth = new Date().getMonth() + 1; // Mois actuel (1-12)
        let filtered = carburants;
        filtered = carburants.filter((item) => {
            const itemMonth = new Date(item.date_carburant).getMonth() + 1;
            const matchesMonth = selectedMonth ? itemMonth === selectedMonth : itemMonth === currentMonth;
            const matchesSearch = item.immatriculation && item.immatriculation.toLowerCase().includes(filterText.toLowerCase()) ||
                item.ets_nom && item.ets_nom.toLowerCase().includes(filterText.toLowerCase()) ||
                item.recever && item.recever.toLowerCase().includes(filterText.toLowerCase()) ||
                item.designation && item.designation.toLowerCase().includes(filterText.toLowerCase()) ||
                item.date_carburant && item.date_carburant.toLowerCase().includes(filterText.toLowerCase());
            return matchesMonth && matchesSearch;
        });

        // Filtrer par statut
        if (filter.status) {
            filtered = filtered.filter((item) => item.status === filter.status);
        }

        if (data.quantite_litre || data.prix_par_litre) {
            setData((prevState) => ({
                ...prevState,
                montant: data.quantite_litre * data.prix_par_litre
            }));
        }

        etablissement.map((item, index) => {
            if (item.status == 'actif' && item.is_default == 1) {
                setData((prevState) => ({
                    ...prevState,
                    etsInfos: item.id ?? 0
                }));
            }
        })

        setFilteredItems(filtered);
        setTimeout(() => {
            if (filteredItems.length > 0) {
                setIsLoading(false); // Les données sont chargées, on arrête le loader
              } else {
                setIsLoading(false)
              }
          }, 2000);
    }, [carburants, filterText, filter, data.quantite_litre, data.prix_par_litre, selectedMonth, etablissement, refresh]);

    const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setSelectedMonth(value ? parseInt(value) : null);
    };

    const isFiltered = filterText !== "" || selectedMonth !== null || filter.status !== "";

    return (
        <div className='page-body'>
            {isLoading && filteredItems.length > 0 ? (
                <div className="loading-container">
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <span className="loading-text">Chargement de la plateforme...</span>
                    </div>
                </div>
            ) : ( 
                <>
                    <Breadcrumbs mainTitle="Bon De Carburant" parent="Carburants" />
                    <Container fluid>

                        <Row>
                            <Col sm="12">
                                {
                                    cardCarburant({ value: filteredItems })
                                }
                            </Col>
                            <Col lg="8">
                                <Card>
                                    <CardBody>
                                        <Row className="mb-0">
                                            <Col sm="3">
                                                {
                                                    (itemHasPermission('super admin') || itemHasPermission('gest. carburant ecriture')) && (
                                                        <Btn color="light-success" className="w-100 mb-2" onClick={handleSubmit}>Payer</Btn>
                                                    )
                                                }
                                                <Btn color="danger" className="w-100 mt-2" onClick={clearFilters} disabled={!isFiltered}>
                                                    <i className="fa fa-times"></i> Réinitialiser
                                                </Btn>
                                                
                                            </Col>
                                            <Col sm="9">
                                                {/* <Label className="me-2">Rechercher:</Label> */}
                                                <Input
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                    type="search"
                                                    placeholder="Rechercher..."
                                                    className="mb-2"
                                                    value={filterText}
                                                />
                                                <Row className="mt-2">
                                                    <Col sm="6">
                                                        {/* <Label className="me-2">Statut:</Label> */}
                                                        <Input type="select" name="status" className="form-control" onChange={changeFilter} value={filter.status}>
                                                            <option value="">Statut...</option>
                                                            <option value="payed">Payé</option>
                                                            <option value="no-payed">Non Payé</option>
                                                        </Input>
                                                    </Col>
                                                    <Col sm="6">
                                                        {/* <Label className="me-2">Filtrer par mois:</Label> */}
                                                        <Input name="type" value={selectedMonth || ''} className="form-control" onChange={handleMonthChange} type="select">
                                                            <option value="">Mois actuel</option>
                                                            <option value="1">Janvier</option>
                                                            <option value="2">Février</option>
                                                            <option value="3">Mars</option>
                                                            <option value="4">Avril</option>
                                                            <option value="5">Mai</option>
                                                            <option value="6">Juin</option>
                                                            <option value="7">Juillet</option>
                                                            <option value="8">Août</option>
                                                            <option value="9">Septembre</option>
                                                            <option value="10">Octobre</option>
                                                            <option value="11">Novembre</option>
                                                            <option value="12">Décembre</option>
                                                        </Input>
                                                    </Col>
                                                </Row>

                                            </Col>
                                            
                                            
                                            
                                        </Row>

                                    </CardBody>
                                </Card>
                                <Table responsive id="all-invoice" striped={true}>
                                    <thead className="bg-info">
                                        <tr>
                                            <th className="text-white">Id</th>
                                            <th className="text-white ps-4">Receveur & Date</th>
                                            <th className="text-white ">Immatriculation & Designation</th>
                                            <th className="text-white ">Quantité & Montant</th>
                                            <th className="text-white ">Status</th>
                                            <th className="text-white ">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredItems.map((item, index) => (
                                            <tr key={item.id}>
                                                <th scope='row'>
                                                    <span className="fw-bold">
                                                        #{index + 1}
                                                    </span>
                                                </th>
                                                <td>
                                                    <span className="fw-bold text-capitalize">
                                                        {item.recever}
                                                    </span> <br></br>
                                                    <span>
                                                        {formatDate(item.date_carburant)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-capitalize">
                                                        {item.immatriculation}
                                                    </span> <br></br>
                                                    <span>
                                                        {item.designation}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-capitalize">
                                                        {formatPrice(item.montant)}
                                                    </span> <br></br>
                                                    <span>
                                                        {parseInt(item.quantite_litre).toLocaleString('gn-GN')} x {formatPrice(item.prix_par_litre)}/L
                                                    </span>
                                                </td>
                                                <td>
                                                    {item.status === 'payed' ? (
                                                        <span className="fw-bold">
                                                            Payed
                                                        </span>
                                                    ) : (
                                                        <span className="text-danger fw-bold" style={{ cursor: "pointer" }} onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                            No-Payed
                                                        </span>
                                                    )}
                                                </td>
                                                <td>
                                                    <Link className='btn bg-dark btn-xs mx-1 my-1' to={`/show-bon-de-carburant/${item.id}`}>
                                                        <i className='fa fa-eye'></i>
                                                    </Link>
                                                    {
                                                        (itemHasPermission('super admin') || itemHasPermission('gest. carburant ecriture')) && (

                                                            item.status === 'payed' ? (
                                                                null
                                                            ) : (
                                                                <>
                                                                    <Btn className='bg-info btn-xs mx-1 my-1' onClick={() => editerData({ id: item.id })}>
                                                                        <i className='fa fa-pencil'></i>
                                                                    </Btn>
                                                                    <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'supprimer' })}>
                                                                        <i className='fa fa-trash'></i>
                                                                    </Btn>
                                                                </>
                                                            )

                                                        )
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Col>
                            <Col lg="4">
                                <Card>
                                    <CardBody>
                                        <Form onSubmit={handleSubmitData}>
                                            <H4 className="my-4 text-capitalize">
                                                {data.id == null ? ("Faire un bon de carburant") : ("Modifier un bon carburant ")}
                                            </H4>
                                            <div className="product-info">
                                                <div className="product-group">
                                                    <Row>
                                                        <Col sm="12">
                                                            <FormGroup>
                                                                <Label>Etablissement</Label>
                                                                <Input
                                                                    placeholder="Entrer le type"
                                                                    name="etsInfos"
                                                                    value={data.etsInfos}
                                                                    onChange={changeHandler}
                                                                    type="select"
                                                                    className="form-control" disabled
                                                                >
                                                                    <option value=''>Selectionner...</option>
                                                                    {
                                                                        etablissement.map((item, index) => {
                                                                            if (item.status == 'actif' && item.is_default == 1) {
                                                                                return <option key={index} value={item.id} selected={true}>{item.nom}</option>
                                                                            } return null;
                                                                        })
                                                                    }
                                                                </Input>
                                                                {erreur.etsInfos && (
                                                                    <span className="text-danger">{erreur.etsInfos}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Immatriculation</Label>
                                                                <Input
                                                                    placeholder="Entrer l'Immatriculation"
                                                                    name="immatriculation"
                                                                    value={data.immatriculation}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.immatriculation && (
                                                                    <span className="text-danger">{erreur.immatriculation}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Destination</Label>
                                                                <Input
                                                                    placeholder="Entrer la destination"
                                                                    name="designation"
                                                                    value={data.designation}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.designation && (
                                                                    <span className="text-danger">{erreur.designation}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>

                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Quantité en Litre</Label>
                                                                <Input
                                                                    placeholder="Entrer la quantité en litre"
                                                                    name="quantite_litre"
                                                                    value={data.quantite_litre}
                                                                    onChange={changeHandler}
                                                                    type="number"
                                                                />
                                                                {erreur.quantite_litre && (
                                                                    <span className="text-danger">{erreur.quantite_litre}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Prix par Litre</Label>
                                                                <Input
                                                                    placeholder="Le Montant"
                                                                    name="prix_par_litre"
                                                                    value={data.prix_par_litre}
                                                                    onChange={changeHandler}
                                                                    type="number"
                                                                />
                                                                {erreur.prix_par_litre && (
                                                                    <span className="text-danger">{erreur.prix_par_litre}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Montant</Label>
                                                                <Input
                                                                    placeholder="Le Montant"
                                                                    name="montant"
                                                                    value={data.montant}
                                                                    onChange={changeHandler}
                                                                    type="number"
                                                                    disabled
                                                                />
                                                                {erreur.montant && (
                                                                    <span className="text-danger">{erreur.montant}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Date</Label>
                                                                <Input
                                                                    placeholder="Le Montant"
                                                                    name="date_carburant"
                                                                    value={data.date_carburant}
                                                                    onChange={changeHandler}
                                                                    type="date"
                                                                />
                                                                {erreur.date_carburant && (
                                                                    <span className="text-danger">{erreur.date_carburant}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="12">
                                                            <FormGroup>
                                                                <Label>Receveur</Label>
                                                                <Input
                                                                    placeholder="Entrer le nom du receveur"
                                                                    name="recever"
                                                                    value={data.recever}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.recever && (
                                                                    <span className="text-danger">{erreur.recever}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                            {
                                                (itemHasPermission('super admin') || itemHasPermission('gest. carburant ecriture')) && (
                                                    <div className="text-end">
                                                        <Btn color="info" type="submit" disabled={isSubmitting}>
                                                            {data.id == null ? (isSubmitting ? "En cours d'ajout..." : "Ajouter") : (isSubmitting ? "Sauvegarde en cours..." : "Sauvegarder")}
                                                        </Btn>
                                                        <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>
                                                            Annuler
                                                        </Btn>
                                                    </div>
                                                )}

                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                 </>
            )}
        </div>
    );
};

export default GestCarburant